import { localize } from "@/i18n/translate";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useContent } from "@/i18n/LangContext";
import { Reveal, SectionHead } from "./Reveal";
export const Card = ({
  p,
  i,
  t
}) => <Reveal delay={i * 0.08} className="h-full">
    <Link to={`/publikationen/${p.slug}`} data-testid={`pub-article-${i + 1}`} className="group flex h-full flex-col border-t border-ink pt-5">
      <div className="flex items-center justify-between font-mono text-xs uppercase tracking-[0.18em] text-mute">
        <span>{localize(p.date)}</span>
        <span>{localize(p.lang)}</span>
      </div>
      <div className="relative mt-5 aspect-[4/3] overflow-hidden bg-ink">
        <img src={p.img} alt="" loading="lazy" className="h-full w-full object-cover opacity-90 grayscale transition-[transform,filter,opacity] duration-700 group-hover:scale-105 group-hover:opacity-100 group-hover:grayscale-0" />
        <span className="absolute left-0 top-0 h-10 w-10 bg-signal transition-[width] duration-500 group-hover:w-16" aria-hidden="true" />
      </div>
      <h3 className="mt-6 font-display text-xl font-bold leading-snug tracking-[-0.01em] text-ink transition-colors group-hover:text-signal md:text-2xl">
        {localize(p.title)}
      </h3>
      <p className="mt-3 leading-relaxed text-mute">{localize(p.teaser)}</p>
      <span className="mt-auto inline-flex items-center gap-2 pt-6 text-sm font-medium text-ink">
        {localize(t.read)}
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" />
      </span>
    </Link>
  </Reveal>;
export const Publications = () => {
  const {
    PUBLICATIONS,
    ui
  } = useContent();
  const t = ui.pubs;
  return <section id="publikationen" data-testid="publications-section" className="border-t border-ink/10 bg-paper">
    <div className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 md:py-32 lg:px-12">
      <SectionHead index="04" label={t.label} title={localize(t.title)} intro={t.intro} />
      <div className="mt-16 grid gap-x-6 gap-y-14 md:mt-20 md:grid-cols-2 lg:grid-cols-3">
        {localize(PUBLICATIONS.map((p, i) => <Card key={p.slug} p={p} i={i} t={t} />))}
      </div>
    </div>
  </section>;
};
